import React from "react";
import { Link } from "react-router-dom";
import IntersectGrid from "@/components/IntersectMotif";
import { useLang } from "@/lib/i18n";

export default function NotFound() {
  const { t } = useLang();
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-testid="not-found">
      <IntersectGrid cols={5} rows={4} />
      <div className="relative z-10 text-center container-x">
        <p className="serif-italic text-8xl md:text-9xl text-luxury-gold">404</p>
        <h1 className="mt-4 text-2xl md:text-3xl font-light text-ivory">{t("This intersection doesn't exist.")}</h1>
        <p className="mt-4 text-muted-text">{t("The page you are looking for could not be found.")}</p>
        <Link to="/" className="btn-gold mt-10" data-testid="notfound-home">{t("Return Home")}</Link>
      </div>
    </section>
  );
}
